import { gate } from 'hub-http/gates';
export const RR_USE_TRANSITIONAL_SELECT_GATE = gate('RR:UseTransitionalSelect');